"use strict";
(function ($) {
    "use strict";
    if (document.querySelectorAll('.c-fwc-results').length > 0) {
        // Get value from the URL GET parameter to provide right content for given results
        function getResult(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"), results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
        var bar = $("#js-c-fwc-results");
        var result = getResult("result");
        if (result > 100) {
            result = '100';
        }
        else if (result < 0) {
            result = '0';
        }
        if (result) {
            switch (true) {
                case (0 <= result && result < 40):
                    bar.find(".c-fwc-results__label--struggling").addClass("c-fwc-results__label--active");
                    break;
                case (40 <= result && result < 60):
                    bar.find(".c-fwc-results__label--coping").addClass("c-fwc-results__label--active");
                    break;
                case (60 <= result && result < 80):
                    bar.find(".c-fwc-results__label--managing").addClass("c-fwc-results__label--active");
                    break;
                case (80 <= result && result <= 100):
                    bar.find(".c-fwc-results__label--thriving").addClass("c-fwc-results__label--active");
                    break;
            }
        }
        // Calculator progress bar
        function runProgress() {
            var elem = document.getElementById("js-c-fwc-results__bar");
            var percentage = document.getElementById("js-c-fwc-results__progress");
            var width = 1;
            var id = setInterval(frame, 10);
            function frame() {
                if (width >= result) {
                    clearInterval(id);
                }
                else {
                    width++;
                    elem.style.width = width + '%';
                    percentage.innerHTML = width * 1 + '<span>%</span';
                }
            }
            elem.className += " fade-in";
        }
        setTimeout(runProgress, 1000);
    }
})(jQuery);
